import { c as _c } from "react/compiler-runtime";
import { type JSX } from "react";
interface CalendarClosedIconProps {
  readonly className?: string | undefined;
}

/**
 * Calendar with X icon for submissions closed state
 */
export default function CalendarClosedIcon(t0) {
  const $ = _c(8);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect x="3" y="6" width="18" height="15" rx="2" stroke="currentColor" strokeWidth="1.5" />;
    t3 = <path d="M3 10H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t4 = <path d="M8 3V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t5 = <path d="M16 3V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t6 = <path d="M9 16L15 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t7 = <path d="M15 16L9 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== className) {
    t8 = <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[6] = className;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  return t8;
}